if (!customElements.get('sm-circle-collection-nav')) {
  customElements.define(
    'sm-circle-collection-nav',
    class SmCircleCollectionNav extends HTMLElement {
      constructor() {
        super();

        this.handleScroll = this.handleScroll.bind(this);
        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.update = this.update.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('[data-sm-circle-nav-viewport]');
        this.prevButton = this.querySelector('[data-sm-circle-nav-prev]');
        this.nextButton = this.querySelector('[data-sm-circle-nav-next]');

        if (!this.viewport) return;

        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.prevButton && this.prevButton.addEventListener('click', this.handlePrevClick);
        this.nextButton && this.nextButton.addEventListener('click', this.handleNextClick);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.viewport);
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.viewport) {
          this.viewport.removeEventListener('scroll', this.handleScroll);
        }
        this.prevButton && this.prevButton.removeEventListener('click', this.handlePrevClick);
        this.nextButton && this.nextButton.removeEventListener('click', this.handleNextClick);
        this.resizeObserver && this.resizeObserver.disconnect();

        if (this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }

      handleScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      }

      handlePrevClick() {
        this.scroll(-1);
      }

      handleNextClick() {
        this.scroll(1);
      }

      scroll(direction) {
        if (!this.viewport) return;
        const distance = Math.max(this.viewport.clientWidth * 0.78, 260);
        this.viewport.scrollBy({
          left: distance * direction,
          behavior: 'smooth',
        });
      }

      update() {
        if (!this.viewport) return;

        const maxScroll = Math.max(this.viewport.scrollWidth - this.viewport.clientWidth, 0);
        const currentScroll = this.viewport.scrollLeft;
        const isOverflowing = maxScroll > 2;

        this.classList.toggle('is-overflowing', isOverflowing);

        if (this.prevButton) {
          this.prevButton.disabled = !isOverflowing || currentScroll <= 2;
        }

        if (this.nextButton) {
          this.nextButton.disabled = !isOverflowing || currentScroll >= maxScroll - 2;
        }
      }
    }
  );
}
